module.exports = __webpack_public_path__ + "static/media/about-img-11@2x.234d9320.png";